import { z } from "zod";

export const voucherSchema = () => {
  return z.object({
    name: z.string().min(1),
    type: z.string().min(1),
    valid_until: z
      .any()
      .transform((date) => {
        if (typeof date === "string") return date;

        const isoString = date.toISOString();
        return isoString.split('T')[0];
      })
      .optional()
      .nullable(),
    vouchers: z.string(),
    active: z.boolean().optional(),
  });
};

export type VoucherFormValues = z.infer<ReturnType<typeof voucherSchema>>;
